<ng-container *ngIf="pureFilterStream$ | async as filter">
    <ng-container *ngIf="filter.removable else filterItem">
        <div class="sh-input-field-with-action">
            <div class="sh-input-field-with-action__input sh-clear-margin-right">
                <ng-container *ngTemplateOutlet="filterItem"></ng-container>
            </div>
            <button class="sh-input-field-with-action__action sh-pure-icon-button--small" (click)="onRemoveFilter()">
                <svg sh-icon [size]="IconSizes.SMALL" [name]="'delete'" class="sh-icon-button__icon" aria-hidden="true"></svg>
            </button>
        </div>
    </ng-container>

    <ng-template #filterItem>
        <ng-container [ngSwitch]="filter.filterType">
            <sh-filter-multiselect
                *ngSwitchCase="FilterType.MultiSelect"
                [loading]="loading$ |async "
                [filter]="filter"
                [i18n]="i18n?.filterMultiSelect"
                (filterChanged)="onFilterChange($event)"
            >
            </sh-filter-multiselect>
            <sh-filter-date
                *ngSwitchCase="FilterType.Date"
                [filter]="filter"
                [i18n]="i18n?.filterDate"
                (filterChanged)="onFilterChange($event)"
            ></sh-filter-date>
        </ng-container>
    </ng-template>
</ng-container>
